import React from "react";
import ContentSection from "./../../components/ContentSection";
import TeamBiosSection from "./../../components/TeamBiosSection";
import "./styles.scss";

function AboutPage(props) {
  return (
    <React.Fragment>
      <ContentSection
        color="primary"
        size="large"
        title="The Planeteer Mission"
        subtitle="Our goal is to be your guide on a journey to zero waste. We need to be less wasteful to ensure the environment isn't harmed by our every day activities. The first step begins with you. Take the time to see what habits you are doing which negatively impact the environment and together we can be less wasteful."
      />
      <TeamBiosSection
        color="white"
        size="medium"
        title="Meet the Team"
        subtitle=""
      />
    </React.Fragment>
  );
}

export default AboutPage;
